import React from 'react';
import { useCalendarActionsData } from '../../../../services/calendarActionsProvider';
import {
  registrationEvents,
  useRegistrationControllers,
} from '../../../../services/acceptanceRegistration';

const SetReRegistrationMode = () => {
  const { notify } = useRegistrationControllers();

  const { interval } = useCalendarActionsData();

  const handleClick = () => {
    notify(registrationEvents.reREGISTRATION_FROM_CALENDAR, {
      interval,
    });
  };

  return <div onClick={handleClick}>Перезаписать</div>;
};

export default SetReRegistrationMode;
